intra_module.controller('ErrorCtrl', function($scope, $window) {
	$scope.rollback = () => $window.history.back();
});
